import { updateIntercom } from "./intercom";
import { authActions } from "./store/auth";
import { Dispatch } from "redux";

export const authenticateWithIntercom = ({
  intercomId,
  firstName,
  lastName,
  accountId,
  email,
  dispatch,
  intercomUserHash,
  digitalMarketing
}: {
  intercomId: string;
  firstName: string;
  lastName: string;
  accountId: string;
  email: string;
  dispatch: Dispatch;
  intercomUserHash: string;
  digitalMarketing?: boolean;
}) => {
  updateIntercom({
    intercomId,
    email,
    firstName,
    lastName,
    accountId,
    intercomUserHash,
    digitalMarketing
  });
  analytics.identify(accountId, {
    intercom_id: intercomId
  });
  dispatch(authActions.authenticate({ intercomId: intercomId }));
};
